import { ChangeEvent } from 'react'
import { t } from '@lingui/macro'
import { Grid } from '@mui/material'

import TextInput from '@/components/ui/inputs/TextInput'

import { InsIdentitySearchErrors, InsIdentitySearchFilters } from '../model/patientDirectory.types'
import { InsPatientSearchForm } from './InsPatientSearchForm'

type PatientDirectorySearchControlsProps = {
  isInsMode: boolean
  insErrors: InsIdentitySearchErrors
  insFilters: InsIdentitySearchFilters
  insSearchError: boolean
  updateInsFilter: (patch: Partial<InsIdentitySearchFilters>) => void
  clearInsFilters: () => void
  handleLegacySearchChange: (event: ChangeEvent<HTMLInputElement>) => void
  legacySearchValue: string
}

export function PatientDirectorySearchControls({
  isInsMode,
  insErrors,
  insFilters,
  insSearchError,
  updateInsFilter,
  clearInsFilters,
  handleLegacySearchChange,
  legacySearchValue,
}: PatientDirectorySearchControlsProps) {
  if (isInsMode) {
    return (
      <Grid item xs={12}>
        <InsPatientSearchForm errors={insErrors} filters={insFilters} hasRequestError={insSearchError} onChange={updateInsFilter} onClear={clearInsFilters} />
      </Grid>
    )
  }

  return (
    <Grid item xs={12}>
      <TextInput
        fullWidth
        onChange={handleLegacySearchChange}
        placeholder={t`Search patients (by name, surname, social security number)`}
        value={legacySearchValue}
      />
    </Grid>
  )
}
